import { Injectable, inject } from '@angular/core'
import { ModalService } from 'src/shared/modal/modal.service'
import {PreviewClientShippingLogComponent, PreviewClientShippingLogOptions} from './preview-client-shipping-log.component'

@Injectable()
export class PreviewClientShippingLogService {
  private modal = inject(ModalService)


  async show(options: PreviewClientShippingLogOptions) {
    return this.modal.openDialog<PreviewClientShippingLogComponent,
        PreviewClientShippingLogOptions, void>(PreviewClientShippingLogComponent,
     options, {
       width: '100%',
       maxWidth: '100%',
    })
  }
}
